import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { QueryBuilderForm } from 'modules/queryBuilder/QueryBuilderForm';
import { ESIndex } from 'modules/queryBuilder/types';
import { useSegmentationQuerySchema } from './schema/hooks';
import { queryBuilderVisualComponents } from './queryBuilderVisualComponents';
import { SidePanel } from '../sidePanel/SidePanel';
import { FORM_ID } from '../../constants';
import { useSegmentationQueryContext } from '../../contexts/segmentationQuery';
import {
  useOnSubmitSegmentationQuery,
  usePrepopulatedSegmentationQuery,
  useResetLocationState,
} from '../../hooks';
import { SegmentationQueryBuilderErrorBoundary } from '../../contexts/errorBoundary';

export const testIds = {
  queryBuilderWrapper: 'querybuilder-wrapper',
};

const QueryBuilderWrapper = styled.div`
  align-items: flex-start;
  border-top: ${spacing.single} solid ${colors.borderPrimarySubtle};
  display: flex;
  gap: ${spacing.plusHalf};
  padding: ${spacing.double};
  width: 100%;
  z-index: 2; /* just enough to get the side-panel drop down over the insights-toolbar-actions */

  > :first-child {
    flex: 1 1 0;
    min-width: 0;
  }
`;

export const QueryBuilder = () => {
  const onSubmit = useOnSubmitSegmentationQuery();
  const { setEditableQuery, setIsValidQuery } = useSegmentationQueryContext();
  const prepopulatedQuery = usePrepopulatedSegmentationQuery();
  const segmentationQuerySchema = useSegmentationQuerySchema();

  /** reset location state in queryBuilder */
  useResetLocationState();

  return (
    <SegmentationQueryBuilderErrorBoundary>
      <QueryBuilderWrapper data-test={testIds.queryBuilderWrapper}>
        <QueryBuilderForm
          esIndex={ESIndex.UserAndEvent}
          hasCustomValidationHandling
          id={FORM_ID}
          onSetEditableQuery={setEditableQuery}
          onSubmitError={() => setIsValidQuery(false)}
          onSubmitSuccess={onSubmit}
          query={prepopulatedQuery}
          querySchema={segmentationQuerySchema}
          visualComponents={queryBuilderVisualComponents}
        />
        <SidePanel />
      </QueryBuilderWrapper>
    </SegmentationQueryBuilderErrorBoundary>
  );
};
